import { INVENTORY_ACTIONS_MAP_STATE_DE } from './stateChange/de'
import { INVENTORY_ACTIONS_MAP_STATE_FR } from './stateChange/fr'
import { INVENTORY_ACTIONS_MAP_STATE_IT } from './stateChange/it'

export const INVENTORY_ACTIONS_MAP_STATE = {
  de: INVENTORY_ACTIONS_MAP_STATE_DE,
  fr: INVENTORY_ACTIONS_MAP_STATE_FR,
  it: INVENTORY_ACTIONS_MAP_STATE_IT,
}
